import React from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import projects from "./projectsData";

const PROCUREMENT_DOCUMENT_URL =
  "/Prilozi/prodigy-e/odluka-jednostavna-nabavka-opreme-prodigy-e-25-08-2026.pdf";
const PROCUREMENT_EMAIL = "fpebar@gmail.com";

function ProjectSinglePRODIGYE() {
  const { t } = useTranslation("projectsTranslation");
  const ns = "projectsTranslation";

  const project = projects.find((p) => p.i18nKey === "prodigye");
  const baseKey = "projects.prodigye";

  const intro = t(`${baseKey}.page.intro`, { ns, returnObjects: true });
  const objectives = t(`${baseKey}.page.objectives`, {
    ns,
    returnObjects: true,
  });
  const activities = t(`${baseKey}.page.activities`, {
    ns,
    returnObjects: true,
  });
  const results = t(`${baseKey}.page.results`, { ns, returnObjects: true });
  const consortium = t(`${baseKey}.page.consortium`, {
    ns,
    returnObjects: true,
  });

  return (
    <>
      <Navbar />
      <Bredcom subtitle={t(`${baseKey}.page.title`, { ns })} />

      <div className="container mt-4 pt-40 project-detail prodigye-page">
        <div className="row">
          {/* LEFT CONTENT */}
          <div className="col-lg-8 col-md-7">
            <div className="content-container lower-content">
              <div className="project-logos mb-4">
                {/* <span className="project-eu-text">
                  {t(`${baseKey}.page.euFunding`, { ns })}
                </span> */}
              </div>

              {/* {project?.coverImage && (
                <div className="project-cover mb-4">
                  <img
                    src={project.coverImage}
                    alt={t(`${baseKey}.page.title`, { ns })}
                    className="img-fluid"
                    style={{ borderRadius: 16, width: "100%" }}
                  />
                </div>
              )} */}

              {project?.logoImage && (
                <div className="project-logos mb-4">
                  <img
                    src={project.logoImage}
                    alt="PRODIGY-E logo"
                    className="project-logo-main"
                  />
                </div>
              )}

              <h2 className="section-title">
                {t(`${baseKey}.page.title`, { ns })}
              </h2>

              <div className="textjustify">
                {(Array.isArray(intro) ? intro : []).map((p, idx) => (
                  <p key={`intro-${idx}`}>{p}</p>
                ))}
              </div>

              <section
                id="javni-pozivi"
                className="prodigye-procurement"
                aria-labelledby="prodigye-procurement-title"
              >
                <div className="prodigye-procurement__header">
                  <span
                    className="prodigye-procurement__icon"
                    aria-hidden="true"
                  >
                    <i className="fas fa-file-contract" />
                  </span>
                  <div>
                    <span className="prodigye-procurement__eyebrow">
                      {t(`${baseKey}.page.procurement.eyebrow`, { ns })}
                    </span>
                    <h3
                      id="prodigye-procurement-title"
                      className="prodigye-procurement__title"
                    >
                      {t(`${baseKey}.page.procurement.title`, { ns })}
                    </h3>
                  </div>
                </div>

                <p className="prodigye-procurement__description">
                  {t(`${baseKey}.page.procurement.description`, { ns })}
                </p>

                <div
                  className="prodigye-procurement__meta"
                  aria-label={t(`${baseKey}.page.procurement.detailsLabel`, {
                    ns,
                  })}
                >
                  <span>
                    <i className="far fa-calendar-alt" aria-hidden="true" />
                    <strong>
                      {t(`${baseKey}.page.procurement.decisionDateLabel`, {
                        ns,
                      })}
                      :
                    </strong>{" "}
                    {t(`${baseKey}.page.procurement.decisionDate`, { ns })}
                  </span>
                  <span>
                    <i className="fas fa-file-pdf" aria-hidden="true" />
                    {t(`${baseKey}.page.procurement.documentMeta`, { ns })}
                  </span>
                </div>

                <div className="prodigye-procurement__deadline" role="note">
                  <i className="far fa-clock" aria-hidden="true" />
                  <div>
                    <strong>
                      {t(`${baseKey}.page.procurement.deadlineLabel`, { ns })}
                    </strong>
                    <span>
                      {t(`${baseKey}.page.procurement.deadline`, { ns })}
                    </span>
                  </div>
                </div>

                <div className="prodigye-procurement__submission">
                  <i className="far fa-envelope" aria-hidden="true" />
                  <span>
                    {t(`${baseKey}.page.procurement.submissionLabel`, { ns })}
                  </span>
                  <a href={`mailto:${PROCUREMENT_EMAIL}`}>
                    {PROCUREMENT_EMAIL}
                  </a>
                </div>

                <p className="prodigye-procurement__note">
                  {t(`${baseKey}.page.procurement.documentNote`, { ns })}
                </p>

                <div className="prodigye-procurement__actions">
                  <a
                    className="prodigye-procurement__button prodigye-procurement__button--primary"
                    href={PROCUREMENT_DOCUMENT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-external-link-alt" aria-hidden="true" />
                    {t(`${baseKey}.page.procurement.viewButton`, { ns })}
                  </a>
                  <a
                    className="prodigye-procurement__button prodigye-procurement__button--secondary"
                    href={PROCUREMENT_DOCUMENT_URL}
                    download="odluka-jednostavna-nabavka-opreme-prodigy-e-25-08-2026.pdf"
                  >
                    <i className="fas fa-download" aria-hidden="true" />
                    {t(`${baseKey}.page.procurement.downloadButton`, { ns })}
                  </a>
                </div>
              </section>

              {/* Objectives */}
              <h3 className="mt-30">
                {t(`${baseKey}.page.objectivesTitle`, { ns })}
              </h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(objectives) ? objectives : []).map(
                    (item, idx) => (
                      <li key={`obj-${idx}`}>{item}</li>
                    )
                  )}
                </ul>
              </div>

              {/* Activities */}
              <h3 className="mt-30">
                {t(`${baseKey}.page.activitiesTitle`, { ns })}
              </h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(activities) ? activities : []).map(
                    (item, idx) => (
                      <li key={`act-${idx}`}>{item}</li>
                    )
                  )}
                </ul>
              </div>

              {/* Impact */}
              <h3 className="mt-30">
                {t(`${baseKey}.page.resultsTitle`, { ns })}
              </h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(results) ? results : []).map((item, idx) => (
                    <li key={`res-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* Consortium */}
              <h3 className="mt-30">
                {t(`${baseKey}.page.consortiumTitle`, { ns })}
              </h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(consortium) ? consortium : []).map(
                    (p, idx) => (
                      <li key={`partner-${idx}`}>{p}</li>
                    )
                  )}
                </ul>
              </div>

              {/* Disclaimer */}
              <div className="ofpep-section mt-30">
                <p className="textjustify">
                  <em>{t(`${baseKey}.page.disclaimer`, { ns })}</em>
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR (do not overcomplicate; keep it “facts”) */}
          <div className="col-lg-4 col-md-5">
            <div className="info-column">
              <div className="inner-column3">
                <h3>{t(`${baseKey}.sidebar.title`, { ns })}</h3>

                <ul className="project-info">
                  <li>
                    <span className="icon">
                      <i className="fas fa-briefcase" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.programmeLabel`, { ns })}</h5>
                      <p>{project?.programme}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-bullhorn" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.callLabel`, { ns })}</h5>
                      <p>{project?.call}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-layer-group" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.focusLabel`, { ns })}</h5>
                      <p>{t(`${baseKey}.sidebar.focusValue`, { ns })}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-globe" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.countriesLabel`, { ns })}</h5>
                      <p>{t(`${baseKey}.sidebar.countriesValue`, { ns })}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-university" />
                    </span>
                    <div>
                      <h5>
                        {t(`${baseKey}.sidebar.coordinatorLabel`, { ns })}
                      </h5>
                      <p>{project?.coordinator}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-users" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.partnersLabel`, { ns })}</h5>
                      <p>{t(`${baseKey}.sidebar.partnersValue`, { ns })}</p>
                    </div>
                  </li>

                  {project?.links?.euPortal && (
                    <li>
                      <span className="icon">
                        <i className="fas fa-external-link-alt" />
                      </span>
                      <div>
                        <h5>{t(`${baseKey}.sidebar.websiteLabel`, { ns })}</h5>
                        <p>
                          <a
                            href={project.links.euPortal}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            ec.europa.eu (Project page)
                          </a>
                        </p>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProjectSinglePRODIGYE;
